import { ReactNode, useState } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';

export interface TooltipProps {
  className?: string;
  children: ReactNode;
  tooltip: ReactNode;
  tooltipClassname?: string;
}

export function TooltipMessage(props: {
  isHovered: boolean;
  tooltipClassname?: string;
  tooltip: ReactNode;
}) {
  return (
    <Transition
      show={props.isHovered}
      enterFrom="opacity-0"
      enterTo="opacity-100"
      enter="transition-opacity duration-100"
      leave="transition-opacity duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
      as="div"
    >
      <div
        className={classNames(
          'absolute transition-all mt-2 bg-white rounded-md p-3 text-xs shadow border text-gray-500 w-56 mx-auto z-50',
          props.tooltipClassname,
        )}
      >
        <div>{props.tooltip}</div>
      </div>
    </Transition>
  );
}
export function Tooltip(props: TooltipProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={classNames('cursor-pointer relative', props.className)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {props.children}
      {!!props.tooltip && (
        <TooltipMessage
          isHovered={isHovered}
          tooltip={props.tooltip}
          tooltipClassname={props.tooltipClassname}
        />
      )}
    </div>
  );
}
